import { VehicleProps } from "./Vehicle.types";
import { Link } from "../../Link";
import { getVehicleName } from "../../../utils/vehicleUtils";
import style from "./Vehicle.module.scss";
import { formatCurrency } from "shared";
import { useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/TagAction.types";

const editVehicleTagAction: TagAction = {
  name: "edit",
  action: "vehicle_link_clicked",
};

export const Vehicle = ({ vehicle, policy }: VehicleProps) => {
  const urls = useUrls();
  const { value, policyItemNumber } = vehicle;
  const { policyNumber, country } = policy;
  const vehicleName = getVehicleName(vehicle);
  const shouldRenderEditVehicle = policy.partner !== "state-farm";

  return (
    <section aria-label={vehicleName} className={style.rowOneWrapper}>
      <div className={style.vehicleWrapper}>
        <h4 title={vehicleName} className={style.vehicleDescriptionText}>
          {vehicleName}
        </h4>
        <span>
          Value: {formatCurrency(value, { country, decimalPlaces: 0 })}
        </span>
      </div>
      {shouldRenderEditVehicle && (
        <Link
          className={style.editLink}
          ariaLabel={`Edit your ${vehicleName} vehicle details on policy ${policyNumber}`}
          href={urls.insurance.editVehicle(
            policyNumber,
            policyItemNumber,
            country
          )}
          tagAction={editVehicleTagAction}
        >
          Edit vehicle
        </Link>
      )}
    </section>
  );
};
